import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class ImgAndTextFlow extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const platformList = content.map((currentPlatForm, index) => {
            return (
                <li key={index} className={styles.imgAndTextFlow}>
                    <a href={currentPlatForm.url} target="_blank" rel="noopener noreferrer">
                        <img src={currentPlatForm.thumbnail} />
                        <div>
                            <h3>{currentPlatForm.title}</h3>
                            <p>{currentPlatForm.summary}</p>
                        </div>
                    </a>
                </li>
            );
        });

        return platformList;
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
ImgAndTextFlow.propTypes = { content: PropTypes.array };

/**
 * 定义组件默认属性
 * */
ImgAndTextFlow.defaultProps = {};

export default ImgAndTextFlow;
